import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import Api from "../../../Services/Api";
import {Status} from "../../common/Constants";
import {mapToObjectDDL} from "../../common/mapper";

class MasterKasFilter extends Component {
    statusOptions = [
        {
            label: Status.ACTIVE,
            value: Status.ACTIVE,
        },
        {
            label: Status.INACTIVE,
            value: Status.INACTIVE,
        },
    ];

    constructor(props) {
        super(props);
        this.filterInitialData = {
            kodeKas: null,
            kodeCabang: null,
            name: null,
            status: null,
        };
        this.state = {
            filterData: {...this.filterInitialData},
            cabangOptions: [],
        };
    }

    async componentDidMount() {
        const response = await Api.create(
            "NAGAMAS_MASTER_DATA"
        ).findAllMasterCabang();
        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                cabangOptions: response.data.data.map((value) =>
                    mapToObjectDDL(value.namaDealer, value.kodeCabang)
                ),
            }));
        }
    }

        handleValueChange = (name, value) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    getFilterDataValue = (fieldName, fallbackValue = "") => {
        return !R.isNil(this.props.state.filterData) &&
        this.props.state.filterData[fieldName]
            ? this.props.state.filterData[fieldName]
            : fallbackValue;
    };

    render() {
        return (
            <SimpleModal
                title="Filter"
                visible={this.props.state.filterVisible}
                onClickClose={this.props.onClickClose}
                content={
                    <ModalContainer>
                        <SimpleInput
                            id="input_text_kode_kas"
                            name="kodeKas"
                            label="Kode Kas"
                            value={this.getFilterDataValue("kodeKas")}
                            onChange={({target}) =>
                                this.handleValueChange(target.name, target.value)
                            }
                        />
                        <SimpleDDL
                            id="select_options_nama_cabang"
                            name="kodeCabang"
                            label="Nama Cabang"
                            box="search"
                            isClearable
                            options={this.state.cabangOptions}
                            value={this.getFilterDataValue("kodeCabang", null)}
                            onChange={(value, {name}) =>
                                this.handleValueChange(name, value)
                            }
                        />
                        <SimpleInput
                            id="input_text_nama_kas"
                            name="name"
                            label="Nama Kas"
                            value={this.getFilterDataValue("name")}
                            onChange={({target}) =>
                                this.handleValueChange(target.name, target.value)
                            }
                        />
                        <SimpleDDL
                            id="input_text_status"
                            name="status"
                            label="Status"
                            box="search"
                            options={this.statusOptions}
                            isClearable
                            value={
                                !R.isNil(this.props.state.filterData) &&
                                this.props.state.filterData.status
                                    ? this.props.state.filterData.status
                                    : null
                            }
                            onChange={(value, {name}) =>
                                this.handleValueChange(name, value)
                            }
                        />
                        <FlexView hAlignContent="center">
                            <SimpleButton
                                type="button"
                                secondary
                                onClick={this.props.onReset}
                            >
                                Hapus
                            </SimpleButton>
                            <SimpleButton onClick={this.props.onSubmit}>Terapkan</SimpleButton>
                        </FlexView>
                    </ModalContainer>
                }
            />
        );
    }
}

export default MasterKasFilter;
